import {
  FETCH_LOCATION_INSIGHTS,
  FETCH_LOCATION_INSIGHTS_FAILURE,
  FETCH_LOCATION_INSIGHTS_SUCCESS,
} from "./constants";

const action = (type) => (payload) => ({ type, payload });

export const fetchLocationInsights = action(FETCH_LOCATION_INSIGHTS);
export const fetchLocationInsightsSuccess = action(
  FETCH_LOCATION_INSIGHTS_SUCCESS,
);
export const fetchLocationInsightsFailure = action(
  FETCH_LOCATION_INSIGHTS_FAILURE,
);
